import React from 'react';

import './restricted-question-message.scss';

export default function RestrictedQuestionMessage() {
  return (
    <div className='restricted-question-message'>
      <span className='restricted-question-message__icon fa fa-exclamation-triangle' />
      <p className='restricted-question-message__message'>
        <span className='avoid-wrap'>Sorry, this question is part of an active assignment.</span>
        <span className='avoid-wrap'>
          You won&apos;t be able to access it until the assignment is complete.
        </span>
      </p>
    </div>
  );
}
